import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=3b56fdbe&scoped=true&lang=pug"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b56fdbe",
  null
  
)

export default component.exports